import api from './api';
import { SubscriptionLimitCheck } from '../types';

// Planes definidos localmente (igual que en el backend)
const PLANS = {
  free: {
    name: 'free',
    display_name: 'Plan Gratuito',
    price: 0,
    features: {
      basic_tracking: true,
      calendar_view: true,
      advanced_analytics: false,
      export_data: false,
      priority_support: false
    },
    limits: {
      headaches_per_month: 10,
      tensions_per_month: 10,
      lloros_per_month: 10
    }
  },
  premium: {
    name: 'premium',
    display_name: 'Plan Premium',
    price: 4.99,
    features: {
      basic_tracking: true,
      calendar_view: true,
      advanced_analytics: true,
      export_data: true,
      priority_support: false
    },
    limits: {
      headaches_per_month: -1,
      tensions_per_month: -1,
      lloros_per_month: -1
    }
  },
  unlimited: {
    name: 'unlimited',
    display_name: 'Plan Unlimited',
    price: 9.99,
    features: {
      basic_tracking: true,
      calendar_view: true,
      advanced_analytics: true,
      export_data: true,
      priority_support: true
    },
    limits: {
      headaches_per_month: -1,
      tensions_per_month: -1,
      lloros_per_month: -1
    }
  }
};

export type PlanName = 'free' | 'premium' | 'unlimited';

export interface PlanInfo {
  name: string;
  display_name: string;
  price: number;
  features: Record<string, boolean>;
  limits: Record<string, number>;
}

export interface UsageStats {
  plan: PlanName;
  display_name: string;
  usage: {
    headaches: { current: number; limit: number; remaining: number };
    tensions: { current: number; limit: number; remaining: number };
    lloros: { current: number; limit: number; remaining: number };
  };
  features: Record<string, boolean>;
}

// Obtener todos los planes disponibles
export const getPlans = (): PlanInfo[] => {
  return Object.values(PLANS);
};

// Obtener info del plan por nombre
export const getPlanByName = (planName: PlanName): PlanInfo => {
  return PLANS[planName] || PLANS.premium;
};

// Obtener suscripción/plan actual del usuario
export const getCurrentSubscription = async (): Promise<PlanInfo & { plan_name: PlanName }> => {
  const response = await api.get('/subscriptions/current');
  return response.data.data.subscription;
};

// Obtener estadísticas de uso
export const getUsageStats = async (): Promise<UsageStats> => {
  const response = await api.get('/subscriptions/usage');
  return response.data.data.usage;
};

// Verificar límite específico
export const checkLimit = async (limitType: string): Promise<SubscriptionLimitCheck> => {
  const response = await api.get(`/subscriptions/limits/${limitType}`);
  return response.data.data;
};

// Verificar si tiene acceso a una feature
export const checkFeature = async (featureName: string): Promise<boolean> => {
  const response = await api.get(`/subscriptions/feature/${featureName}`);
  return response.data.data.hasFeature;
};

export default {
  getPlans,
  getPlanByName,
  getCurrentSubscription,
  getUsageStats,
  checkLimit,
  checkFeature
};
